import React from 'react';

function Hakkimizda() {
  return (
    <div className="w-full min-h-[calc(100vh-64px)] bg-white">
      {/* Başlık */}
      <div className="bg-gradient-to-r from-slate-50 to-slate-100 py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">HAKKIMIZDA</h1>
          <div className="w-20 h-1 bg-primary mx-auto"></div>
        </div>
      </div>

      {/* İçerik */}
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
        {/* Tarihçe */}
        <div className="mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
            <div className="w-1 h-8 bg-primary rounded-full"></div>
            Hakkımızda
          </h2>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">
            Şirketimiz, kurucularından dedemiz İsmail ÖZTÜRK tarafından 1970 yılında kurulmuş olup, ticaret hayatını Mustafa ÖZTÜRK tarafından devam ettirmektedir. Öztürk Kereste, 50 yılı aşkın süredir edindiği tecrübe ve bilgi birikimi ile orman ürünlerinde önemli bir konum elde etmiştir. Kuruluşundan itibaren Türkiye'nin dört bir yanına kereste hizmeti sunmaktadır. Kaliteden ve müşteri memnuniyetinden ödün vermemeyi ilke edinen şirketimiz, ticaret hayatına devam etmektedir.
          </p>
        </div>

        {/* Vizyonumuz */}
        <div className="mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
            <div className="w-1 h-8 bg-primary rounded-full"></div>
            Vizyonumuz
          </h2>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed">
            Şirketimiz, her geçen gün teknoloji ve politikalarıyla kendini yenileyerek en iyi hizmeti sunmayı ilke edinmiştir. Öztürk Kereste, müşteri memnuniyeti odaklı yaklaşımıyla gelişmeyi, evrensel kalite ve standartlarda ürün ve hizmetler sunmayı amaçlamaktadır. Bu sayede ülkesi ve müşterileri için güvenilirlik, devamlılık ve saygınlık simgesi olmayı hedeflemektedir.
          </p>
        </div>

        {/* Misyonumuz */}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 md:p-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
            <div className="w-1 h-8 bg-primary rounded-full"></div>
            Misyonumuz
          </h2>
          <p className="text-gray-700 text-base md:text-lg leading-relaxed">
            Müşterilerimiz için değer yaratmak, beklentilerine kalite ve istikrarla karşılık vermek ilk önceliğimizdir. Ürün ve hizmetlerimize sahip çıkmak ve sonrasında da müşterilerimizin yanında olmak görevimizdir.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Hakkimizda;